<template>
  <v-layout wrap class="cont-general-app-inicio">
    <v-flex xs12 sm8 md9 class="cont-mapa">
      <div class="cont-botones">
        <v-btn color="#16A44E" class="my-1" :class="$store.state.bVerInundacion ? 'btn-activo' : '' " small dark @click="$store.state.bVerInundacion =! $store.state.bVerInundacion">Inundaciones</v-btn>
        <v-btn color="#16A44E" class="my-1" :class="$store.state.bVerDeliz ? 'btn-activo' : '' " small dark @click="$store.state.bVerDeliz =! $store.state.bVerDeliz">Deslizamientos</v-btn>
      </div>
      <div :class="$vuetify.breakpoint.xs ? 'mapaMobile' : 'mapaWeb'" v-if="!cargoMapa"
      class="d-flex justify-center align-center" >
        <v-progress-circular
        :width="5"
        size="50"
        color="primary"
        indeterminate
      ></v-progress-circular>
      </div>

      <l-map :class="$vuetify.breakpoint.xs ? 'mapaMobile' : 'mapaWeb'" :zoom="zoom" :center="center"
      :options="{zoomControl:false, scrollWheelZoom:false}" @update:center="centerUpdated" @update:zoom="zoomUpdated"   v-if="cargoMapa">
        <!-- <l-feature-group ref="featBarrios">
          <l-popup > <span>sdfasd {{nBarrio}}</span></l-popup>
        </l-feature-group> -->
        <l-control-zoom position="bottomright"></l-control-zoom>
        <l-control class="example-custom-control" :position="'bottomright'" >
          <v-icon @click="onCentrarMapa()" >mdi-magnify-expand</v-icon>
        </l-control>
        <l-tile-layer :url="url" :attribution="attribution">
        </l-tile-layer>

        <!-- PUNTOS DE RUTA REMOTOS-->
        <l-marker
          v-for="(marker , n) in geojsonRutaRemoto"
          :key="'markerRuta-'+n"
          :visible="true"
          :draggable="false"
          @click="onPunto(n, marker)"
          :lat-lng="[marker.coordenadas.split(',')[1],marker.coordenadas.split(',')[0]]"
          :update:latLng="[marker.coordenadas.split(',')[1],marker.coordenadas.split(',')[0]]"
        >
          <l-icon
            :icon-size="[30, 45]"
            :icon-anchor="[30, 45]"
            :icon-url="$store.state.rutaApi+marker.icono" >
          </l-icon>
          <l-popup>{{marker.nombre_ruta}}</l-popup>
        </l-marker>

        <!-- PUNTOS DE INTERES REMOTOS-->
        <l-marker
          v-for="(marker , n) in geojsonPuntos"
          :key="'marker-'+n"
          :visible="true"
          :draggable="false"
          :lat-lng="[''+marker.coordenadas.split(',')[1]+'',''+ marker.coordenadas.split(',')[0]+'']"
          :update:lat-lng="[''+marker.coordenadas.split(',')[1]+'',''+ marker.coordenadas.split(',')[0]+'']"
        >
          <l-icon
            :icon-size="[30, 45]"
            :icon-anchor="[30, 45]"
            :icon-url="$store.state.rutaApi+marker.icono" >
          </l-icon>
          <l-popup>{{marker.nombre_punto}}</l-popup>
        </l-marker>

        <!-- BARRIOS GENERAL REMOTO -->
        <l-geo-json :geojson="geojsonBarrios.barrios.features" :visible='bVerBarios'
          :options="{ asFeature: open, style: estiloBarrios}"
          @click="open"
        >
        </l-geo-json>
        <!-- INUNDACION  -->
        <l-geo-json :geojson="geojsonInundacion.inundaciones.features"
         :options="{style: estiloInundaciones}"
         :visible='$store.state.bVerInundacion'
         >
         </l-geo-json>
         <!-- DESLIZAMIENTO  -->
        <l-geo-json :geojson="geojsonDesliz.deslizamientos.features"
        :options="{style: estiloDeslizamiento}"
        :visible='$store.state.bVerDeliz'
        >
        </l-geo-json>

      </l-map>
      <div class="cont-adicional-web mx-auto text-center">
        <p class="mb-0 pa-1">{{textoNotaMapa}}</p>
      </div>
    </v-flex>
    <!-- CONTENIDO VERSION WEB -->
    <v-flex xs12 sm4 md3 :class="$vuetify.breakpoint.xs ? '' : 'cont-panel-web'"  v-if="!$vuetify.breakpoint.xs ">
      <div class="cont-ruta" >
        <div v-for="(item , n) in geojsonRutaRemoto" :key="'item-ruta-'+n"
        class="item-ruta" @click="abrirRuta(n , item)" :class="{'rutaActiva': estadoRutas[n]}" :style="estadoRutas[n] ? 'border:solid 1px'+item.color+';' : ''"
        >
          <div class="item-indicador" :style="{'backgroundColor':item.color}"
          ></div>
          <div class="item-info">
            <!-- <p>Barrio {{n+1}}</p> -->
            <p>{{item.nombre_ruta}}</p>
          </div>
        </div>
      </div>
      <div class="cont-info-ruta">
        <component
        :key="keyprimary"
        :is="componenteActual"
        :obRuta="nRutaActual"
        @accionDesliz="$store.state.bVerDeliz  =! $store.state.bVerDeliz "
        @accionInundacion="$store.state.bVerInundacion =! $store.state.bVerInundacion"
         ></component>
      </div>

    </v-flex>
    <!-- CONTENIDO VERSION MOBILE -->
    <v-flex xs12 sm4 md3 class="cont-panel-mobile" v-if="$vuetify.breakpoint.xs" >
      <v-flex xs12>
        <div v-if="solorutas">
          <div class="cont-ruta-mobile" >
            <div v-for="(item , n) in geojsonRutaRemoto" :key="'item-ruta-'+n"
              class="item-ruta" @click="abrirRuta(n , item)" :class="{'rutaActiva': estadoRutas[n]}" :style="estadoRutas[n] ? 'border:solid 1px'+item.color+';' : ''"
              >
              <div class="item-indicador" :style="{'backgroundColor':item.color}"
              ></div>
              <div class="item-info">
                <!-- <p>Barrio {{n+1}}</p> -->
                <p>{{item.nombre_ruta}}</p>
              </div>
            </div>
          </div>

        </div>
        <div v-if="!solorutas">
          <v-btn @click="regresarRutas()" color="#045FA2" dark class="mx-auto"><v-icon left>mdi-arrow-left-circle</v-icon> Regresar a rutas</v-btn>
          <div class="cont-info-ruta">
            <component
            :key="keyprimary"
            :is="componenteActual"
            :obRuta="nRutaActual"
            @accionDesliz="$store.state.bVerDeliz  =! $store.state.bVerDeliz "
            @accionInundacion="$store.state.bVerInundacion =! $store.state.bVerInundacion"
            ></component>
          </div>
        </div>
          <div class="cont-adicional mx-auto text-center" v-if="cargoMapa">
          <!-- @click="openAdicional" -->
            <!-- <v-icon left color="#0B542D" size="20">mdi-open-in-new</v-icon>
            {{dataTextosAdicionales.titulo}}  -->
            <p class="mb-0 pa-1">{{textoNotaMapa}}</p>
          </div>
      </v-flex>
    </v-flex>

        <!-- MODAL ADICIONAL-->
    <modal-adicional-app v-model="modalTextos" :fullscreen="false" :titulo="dataTextosAdicionales.titulo" v-if="cargoMapa" width="60vw">>
      <template slot="modalcontent">
        <div class="pa-3">
          <p v-html="dataTextosAdicionales.texto"></p>
          <a v-if="dataTextosAdicionales.enlace" :href="dataTextosAdicionales.enlace" target="blank">{{dataTextosAdicionales.enlace}}</a>
        </div>
      </template>
    </modal-adicional-app>

    <!-- MODAL Inicio-->
    <modal-adicional-app v-model="modalInicio" :fullscreen="false" width="50vw" v-if="cargoMapa">
      <template slot="modalcontent">
        <div class="pa-3">
          <h2 v-if="dataTextosIniciales.titulo_bienvenida" v-html="dataTextosIniciales.titulo_bienvenida"></h2>
          <p class="mt-4" v-html="dataTextosIniciales.texto_bienvenida"></p>
        </div>
      </template>
    </modal-adicional-app>

  </v-layout>
</template>

<script>
import axios from "axios"

import inicio from "../components/rutas/compRuta0.vue"
import compRuta from "../components/rutas/compRuta.vue"

export default {
  components: {
    inicio,
    compRuta
  },
  data() {
    return {
      keyprimary:0, // setea el componente de contenido
      componenteActual:'inicio', // Nombre del componente de contenido
      cargoMapa:false, // Loadin de mapa, espera a que termina la consulta
      estiloBarrios : {
        "color": "black",
        "weight": 1,
        "opacity": 0.65,
        "fillColor": "transparent",
      },
      estiloInundaciones: {
        "color": "#3E6D9C",
        "weight": 1,
        "opacity": 0.65
      },
      estiloDeslizamiento: {
        "color": "#DC3535",
        "weight": 1,
        "opacity": 0.65
      },
      geojsonPuntos:null,
      geojsonBarrios:null,
      geojsonInundacion:null,
      geojsonDesliz:null,
      geojsonRutaRemoto:null,
      dataTextosAdicionales:null,
      dataTextosIniciales:null,
      nRutaActual:null,

      modalTextos: false,
      modalInicio: false,

      tab: null,
      latFinal:[],
      poligono:[],
      aDeslizActual:[],
      barriosRutaJson:[],
      posPopBarrios:[],

      nBarrio:'',
      bVerBarios: true,
      idRutaActual: 0,

      drawer: false,
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      urlB: 'http://ows.mundialis.de/services/service?',
      attributionB:'TOPO-WMS',
      // url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      // attribution:'&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 14,
      center:[0.9653114552676624, -79.65106199194697],
      initialMarkers:[],
      markers:[],
      oDataInfoVista:{},
      numLugar:0,
      dataPunto:[],
      contenidoDetalle:'',
      puntoActual: 0,
      puntosVistos: null,
      modalRecurso: false,
      numModalRecurso: 1,
      solorutas: true,
      estadoRutas: null,
      cantidadRutas: 0,
      textoNotaMapa:'Nota: Este mapa de inundaciones y deslizamientos de la ciudad de Esmeraldas es referencial para uso informativo. El mismo no debe ser utilizado para otros fines como un instrumento oficial u actualizado de la ciudad. Fuente: Gobierno Autónomo Descentralizado Municipal del Cantón Esmeraldas, 2004.'
    }
  },
  mounted(){

  },
  async created() {
    // INUNDACIONES
    await axios
    .get(''+this.$store.state.rutaApi+'inundaciones')
    .then(response => (this.geojsonInundacion  = response.data[0]))
    // console.log( "geojsonInundacion  ",this.geojsonInundacion )
    // DESLIZAMIENTOS
    await axios
    .get(''+this.$store.state.rutaApi+'deslizamientos')
    .then(response => (this.geojsonDesliz = response.data[0]))
    // console.log( "geojsonDesliz   ",this.geojsonDesliz )

    // PUNTOS DE INTERES
    await axios
    .get(''+this.$store.state.rutaApi+'puntos-interes')
    .then(response => (this.geojsonPuntos = response.data))
    // console.log( "geojsonPuntos ",this.geojsonPuntos)

    // BARRIOS
    await axios
    .get(''+this.$store.state.rutaApi+'barrios-json')
    .then(response => (this.geojsonBarrios = response.data[0]))
    // console.log( "BARRIOS JSON",this.geojsonBarrios)

    // RUTA REMOTA
    await axios
    .get(''+this.$store.state.rutaApi+'rutas')
    .then(response => (this.geojsonRutaRemoto = response.data))
    // console.log( "geojsonRutaRemoto ",this.geojsonRutaRemoto)
    this.cantidadRutas = this.geojsonRutaRemoto.length
    this.estadoRutas = Array(this.cantidadRutas).fill(false)

     // TEXTOS ADICIONALES
    await axios
    .get(''+this.$store.state.rutaApi+'textos-adicionales')
    .then(response => (this.dataTextosAdicionales = response.data[0]))
    // console.log( "dataTextosAdicionales ",this.dataTextosAdicionales)

    // TEXTOS ADICIONALES
    await axios
    .get(''+this.$store.state.rutaApi+'textos-iniciales')
    .then(response => (this.dataTextosIniciales = response.data[0]))
    //  console.log( "dataTextosIniciales ",this.dataTextosIniciales)


    this.geojsonRutaRemoto.forEach(element => {
      this.onExtraerCoordenada(element)
    });
    this.cargoMapa = true
  },
  methods:{
    onExtraerCoordenada(item){
      this.geojsonBarrios.barrios.features.forEach(element => {
        if(element.properties.id_bar == item.id_bar){
         return item['newCoordenadas']=[element.properties.Latitud , element.properties.Longitud], item['Riesgos']={'Riesgo_D':element.properties.Riesgo_D , 'Riesgo_I' :element.properties.Riesgo_I}
        }
      });
      // console.log( "geojsonRutaRemoto ",this.geojsonRutaRemoto)

    },
    centerUpdated(center){
      // console.log(this.center)
      this.center = center
    },
    zoomUpdated(zoom){
      // console.log(this.zoom)
      this.zoom = zoom
    },
    onCentrarMapa(){
      this.zoomUpdated(14)
      this.centerUpdated([0.9653114552676624, -79.65106199194697])
    },
    onDesliz(num){
      this.latFinal=[]
      this.poligono=[]
      this.aDeslizActual=[]
      this.geojsonDesliz.features.forEach(element => {
        if(element.properties.id_bar == num){
          let deslizActual = element.geometry.coordinates[0][0]
          let tipoRiesgo = element.properties.Num_Riesgo
          let nombreRiesgo = element.properties.NOMBRE
          this.aDeslizActual.push({deslizActual, 'idRiesgo': tipoRiesgo, 'nameRiesgo':nombreRiesgo})
          // console.log('this.aDeslizActual ', this.aDeslizActual)
        }
      });
      this.aDeslizActual.forEach(element => {
        this.crearPoligonoDesliz(element)
      });
    },
    open(val){
      this.zoom = 14
      let itemGeo = val
      this.nBarrio = itemGeo.layer.feature.properties.Nombre_Bar
      let coorPop = [ itemGeo.latlng.lat, itemGeo.latlng.lng]
      this.posPopBarrios = coorPop
      this.center = coorPop
      this.zoom = 16
    },
    regresarRutas(){
      this.solorutas = true
    },
    abrirRuta(val, ruta){
      this.estadoRutas = Array(this.cantidadRutas).fill(false)
      this.$set(this.estadoRutas, val, true)
      this.keyprimary++
      if(this.$vuetify.breakpoint.xs){
        this.solorutas = false
      }
      // console.log('abrir ruta',val , ruta)
      let nuevaCoordenada = [ruta.coordenadas.split(',')[1],ruta.coordenadas.split(',')[0]]
      this.centerUpdated(nuevaCoordenada)
      setTimeout(() => {
        this.zoomUpdated(18)
      }, 500);
      this.componenteActual ='compRuta'
      this.nRutaActual = ruta
    },
    onPunto(val, ruta){
      // console.log(val , ruta)
      let nuevaCoordenada = [ruta.coordenadas.split(',')[1],ruta.coordenadas.split(',')[0]]
      this.centerUpdated(nuevaCoordenada)
      this.zoomUpdated(16)
    },
    openVista(val){
      this.modal = true
      this.numLugar = val
      // console.log(val)
      this.oDataInfoVista = this.aDataInfo[val]
    },
    openAdicional(){
      this.modalTextos = true
    }
  },
  metaInfo: {
    title: 'Narradores',
  },
};
</script>
<style lang="scss" scoped>
.cont-adicional{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: white;
  text-align: center;
  border-radius: 10px;
  align-self: flex-end;
  p{
    font-size: 0.8em;
    line-height: 1em;
  }
}
.cont-info-ruta{
  width: 100%;
  overflow: hidden;
}
.mapaMobile{
  height: calc(40vh - 70px);
  // border: solid blue;
  width:100%;
  z-index:0;
}
.mapaWeb{
  height: calc(100vh - 70px);
  width:100%;
  z-index:0;
}

.cont-conven{
  background: rgba($color: #FFFFFF, $alpha: .5);
  border-radius: 10px 0px 0px 10px;
  padding: 10px;
  position: absolute;
  right: 0px;
  bottom: 20vh;
  height: auto;
  z-index: 1;
  h2{
    font-size: 12px;
  }
  .item-conven{
    margin: 10px 0px;
    display: flex;
    justify-content: end;
    align-items: center;
    p{
      padding-right: 4px;
      font-size: 10px;
      margin: 0px;
    }
  }
}


.btn-activo{
  background: #045FA2!important;
}
.cont-botones{
  position: absolute;
  top: 0px;
  right: 0px;
  display: flex;
  flex-flow: column;
  z-index: 1;

}
.cont-general-app-inicio{
  align-items: stretch;
  height:calc(100vh - 100px);
  padding: 0px;
  flex-direction:row-reverse;
}
.cont-panel-web{
  background: url('../assets/imagenes_compartidas/fondo-panel.png')no-repeat;
  background-position: bottom center;
  background-size: 100%;
  padding: 10px;
  display: flex;
  flex-flow: wrap;
  position: relative;
}
.cont-panel-mobile{
  background: url('../assets/imagenes_compartidas/fondo-panel.png')no-repeat;
  background-position: bottom center;
  background-size: 100%;
  position: relative;
  // border: solid red!important;
  height: 55vh;
  margin-top: -10px;
  overflow-y: auto;
}
.cont-ruta{
  position: absolute;
  right:-200px;
  top: 0px;
  width: 200px;
  height: 100%;
  z-index: 1;
  display: flex;
  flex-flow: column;
  justify-content: center;
  overflow-y: auto;
  padding: 65px 0 20px 0;
  .item-ruta{
    margin: 5px 0px;
    min-height: 50px;
    display: flex;
    justify-content: start;
    align-items: center;
    background: rgba($color: #FFFFFF, $alpha: .7);
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    &:hover{
      background: rgba($color: #FFFFFF, $alpha: 1);
      box-shadow: 0 0 10px #FFFFFF;
      // transform: scale(1.05);
    }
  }
  .item-indicador{
    width: 10px;
    height: 100%;
  }
  .item-info{
    padding-left: 5px;
    // border: solid red;
    p{
      margin: 0px;
      font-weight: 600;
      font-size: 1.1em;
    }
  }
  @media (min-width: 1401px){
    padding: 75px 0 30px;
  }

  @media (max-width: 1400px){
    padding: 390px 0 30px;
  }
}

.cont-ruta-mobile{
  width: 100%;
  height: 50vh;
  display: flex;
  flex-flow: column;
  justify-content: start;
  overflow-y: auto;
  .item-ruta{
    margin: 5px 0px;
    min-height: 50px;
    display: flex;
    justify-content: start;
    align-items: center;
    background: rgba($color: #FFFFFF, $alpha: .8);
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    &:hover{
      background: rgba($color: #FFFFFF, $alpha: 1);
      box-shadow: 0 0 10px #FFFFFF;
    }
  }
  .item-indicador{
    width: 10px;
    height: 100%;
  }
  .item-info{
    padding-left: 5px;
    // border: solid red;
    p{
      margin: 0px;
    }
  }
}
.cont-tab-interna{
  width: 100%;
}

.cont-mapa{
  overflow: hidden;
  position: relative;
}

.cont-info{
  margin-top: 5vh;
  border-radius: 15px 0px 0px 15px;
}
.card-drawer{
  height: 100%;
}
.contenido-superior{
  width: 100%;
  height: 10%;
  background: #004637;
}

.boton-vista{
  color: #004637;
  border: solid #4E9F3D 1px;
  box-shadow: 0 0 10px rgba($color: #000000, $alpha: .9)!important;
  &:hover{
    transform: scale(1.1);
  }
}
.contenido-info{
  height: 89%;
  overflow-y: scroll;
  padding-bottom: 30px!important;
}

.contenedor{
  height: auto;
}
.titulo-card{
  line-height: 1.1em;
  color: #413F42;
}
.item-list{
  .item-icon-play{
    transition: all 0.3s ease-in-out;
  }
  &:hover{
    .item-icon-play{
      transform: translateX(8px);
    }
  }
}
.texto-boton{
  line-height: 1em;
  color: white;
}
.cont-card{
  position: relative;
}
.ajuste-header{
    z-index: 100!important;
    padding: 0px;
    align-items: center;
    .boton-cerrar-modal{
      margin-left: 0 auto;
    }
    .titulo-modal{
      margin: 0 auto;
    }
}
.contenido-card{
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 1000;
}
.rutaActiva{
  background: rgba($color: #FFFFFF, $alpha: 1)!important;
  box-shadow: 0 0 13px #FFFFFF!important;
}

.example-custom-control {
  background: #fff;
  padding: 5px;
  border: 1px solid #aaa;
  border-radius: 0.1em;
  cursor: pointer;
}
.cont-adicional-web{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 70%;
  z-index: 0;
  background: white;
  @media screen and (max-width:600px) {
    display: none;
  }
  p{
    font-size: 0.8em;
    line-height: 1em;
  }
}
 </style>
